import React, { useEffect, useState, Fragment } from "react";
import { Spinner } from "react-bootstrap";
import { connect } from "react-redux";
import { MOBILE_DISPLAY } from "./../../../../constants";
import UeDataBullet from "./UeDataBullet";
import NumberFormat from "react-number-format";

const GeoDataReseaux = (props) => {
   const [isLoading, setIsLoading] = useState(false);
   const [asData, setAsData] = useState(false);
   const [items, setItems] = useState([]);
   let urls = [];
   const [detailView, setDetailView] = useState();

   useEffect(() => {
      fetchData();
   }, [props.keypars]);

   useEffect(() => {
      setAsData(items?.length);
      Object.values(items).map((item, index) => {
         if (item.source === "info") {
            item.urlfic && item.urlfic !== ""
               ? urls.push({
                    title: item.libelle_1,
                    url: item.urlfic,
                    urltype: "ext",
                    section: "information",
                    active: true,
                 })
               : null;
            index === items.length - 1
               ? props.updateFormLinks("information", {
                    id: index,
                    section: "information",
                    subsection: null,
                    order: 1,
                    data: urls,
                 })
               : null;
         }
      });
   }, [items]);

   useEffect(() => {
      setDetailView(props.detailData);
   }, [props.detailData]);

   const fetchData = () => {
      setIsLoading(true);
      const params = {
         key_parcelles: props.keypars,
      };
      axios
         .post("/Api/geodata/stat/parcelle/reseaux", params)
         .then((result) => {
            setItems(result.data);
            setAsData(result.data.length > 0);
            result.data ? props.updateFormData("information", result.data) : null;
            setIsLoading(false);
         })
         .catch((err) => {
            console.log(err);
            props.updateFormData("information", null);
         });
   };
   const renderItem = (item, index, itemLength) => {
      typeof item.sub_items == "string" ? (item.sub_items = JSON.parse(item.sub_items)) : null;
      return (
         <tr key={index}>
            <td width={2}>
               {String(item.id_alea) === "1" || String(item.id_alea) === "0" ? (
                  <UeDataBullet
                     color={String(item.id_alea) === "1" ? "var(--theme-danger)" : "var(--theme-secondary)"}
                  />
               ) : (
                  <UeDataBullet color={"var(--theme-gray1)"} />
               )}
            </td>
            <td className={"text-center"} width={2}>
               {item.urlfic && item.urlfic !== "" ? (
                  <a
                     href={item.urlfic}
                     target="_blank"
                     data-toggle="tooltip"
                     data-placement="top"
                     title="Visualiser le document"
                     className="btn btn-sm p-0"
                  >
                     <i
                        className="bi bi-arrow-down-circle"
                        style={{ fontSize: "16px", color: "var(--theme-primary)" }}
                     />
                  </a>
               ) : (
                  <span style={{ color: "var(--theme_gray1" }}>
                     <i
                        className="bi bi-arrow-down-circle "
                        style={{ fontSize: "16px", color: "var(--theme-light)" }}
                     ></i>
                  </span>
               )}
            </td>
            {item.sub_items
               ? item.sub_items.map((subitem, subindex) => {
                    return renderSubItem(subitem, subindex);
                 })
               : renderSubItem(item, index)}
         </tr>
      );
   };

   const renderSubItem = (subitem, index) => {
      return (
         <Fragment>
            <td>
               <div className={"ue-data-table-label-row"}>
                  {subitem.libelle}{" "}
               </div>
            </td>
            <td style={{ verticalAlign: "middle", width: "110px" }}>
               <div
                  className={"d-flex flex-row justify-content-end px-3 h100"}
                  style={{ verticalAlign: "middle", minWidth: "110px", width: "110px" }}
               >

                  <div style={{ whiteSpace: "nowrap" }}>
                     {subitem.distance}
                     <span className={"d-md-none"}>
                        m
                     </span>
                  </div>
               </div>
            </td>
         </Fragment>
      );
   };

   return (
      <div id={"geodata_information"} className={asData ? "ueGeoDataSubpanel" : null}>
         {
            // INFO
            asData ? (
               <Fragment>
                  <div id={""} />
                  <table className="table table-condensed ue-table-data">
                     <thead>
                        {props.windowsSize > MOBILE_DISPLAY ? (
                           <tr
                              style={{
                                 paddindTop: "3px!important",
                                 color: "#70979A",
                              }}
                           >
                              <th width={"2"}></th>
                              <th width={"2"} className={"text-center"}>
                                 Pdf
                              </th>
                              <th style={{ fontSize: "12px" }}>RÉSEAUX</th>
                              <th
                                 className={"d-flex justify-content-between"}
                                 style={{
                                    fontWeight: "400",
                                 }}
                              >
                                 <span>&nbsp;</span>
                                 <span className={"font-weight-bold"}>Distance</span>
                                 <span>m</span>
                              </th>
                           </tr>
                        ) : (
                           <tr
                              style={{
                                 paddindTop: "3px!important",
                                 color: "#70979A",
                              }}
                           >
                              <th width={"2"}></th>
                              <th width={"2"} className={"text-center"}>
                                 Pdf
                              </th>
                              <th colSpan={2} className={"w-100"} style={{ fontSize: "12px" }}>
                                 RÉSEAUX
                              </th>
                           </tr>
                        )}
                     </thead>
                     <tbody>
                        {Object.values(items).length ? (
                           Object.values(items).map((item, index) => {
                              item && typeof item == "string" ? (item = JSON.parse(item)) : null;
                                 return renderItem(item, index, items.length);
                           })
                        ) : (
                           <tr>
                              <td colSpan={2}>Néant</td>
                           </tr>
                        )}
                     </tbody>
                  </table>
               </Fragment>
            ) : isLoading ? (
               <div className="text-center my-2">
                  <Spinner animation="border" size={"sm"} />
               </div>
            ) : (
               <table className="table table-condensed ue-table-data">
                  <tbody>
                     <tr>
                        <td width={2}>
                           <UeDataBullet color={"var(--theme-light)"} />
                        </td>
                        <td className={"text-center"} width={2}>
                           <i
                              className="bi bi-arrow-down-circle "
                              style={{ fontSize: "16px", color: "var(--theme-light)" }}
                           ></i>
                        </td>
                        <td>Néant</td>
                     </tr>
                  </tbody>
               </table>
            )
         }
      </div>
   );
};

const mapStateToProps = (state) => {
   return {
      detailData: state.LeftPanelReducer.showDetailData,
      windowsSize: state.AppReducer.windowsSize,
   };
};

const mapDispatchTProps = (dispatch) => {
   return {
      updateFormData: (k, e) => dispatch({ type: "UPDATE_FORM_DATA", data: { key: k, data: e } }),
      updateFormLinks: (k, e) => dispatch({ type: "UPDATE_FORM_LINKS", data: { key: k, links: e } }),
   };
};
export default connect(mapStateToProps, mapDispatchTProps)(GeoDataReseaux);
